// extracted by mini-css-extract-plugin
module.exports = {"dialog_wrapper":"Dialog_dialog_wrapper__oqTtr"};